export const BANK_TRANSFER = 'DISCO-engines-bank-transfer';
export const BED_ARRANGEMENT = 'DISCO-bed-arrangement';
export const HOUSE_RULES = 'DISCO-house-rules';
export const CREDIT_CARD_USAGE = 'CreditCardReusage';
export const GROUP_RESERVATIONS = 'DISCO-BE-GROUP-RESERVATIONS';
export const GROUP_RESERVATIONS_TOTAL_PRICE = 'DISCO-BE-GROUP-RESERVATIONS-TOTAL-PRICE'; // used for rollout, remove after total price is allower for all accounts with group reservations
export const RES_UNAVAILABLE_GR_ENABLED = 'RES-unavailable-GR';
export const SHOW_NO_PROPERTIES_PAGE = 'DISCO-BEP-show-no-properties-page';
export const PRICE_FILTER_FIX = 'DISCO-BE-nightly-rates-filter';
export const FORCE_THUMBNAIL_WORKAROUND = 'DISCO-BE-thumbnail-workaround';
export const ZERO_AMOUNT_NOTIFICATION = 'CMGZeroAmountNotification';
export const PRIVACY_POLICY_TERMS = 'DISCO-privacy-policy-terms';
export const UPSELL = 'DISCO-UPSELL';
export const FORTER_3DS = 'GOLD_forter_3ds';
export const DISCO_BE_AUTO_PAYMENT = 'DISCO-BE-auto-payments';
export const DISCO_BE_TOTAL_PRICE_ENGINES = 'DISCO-BE-total-price-engines';
// todo remove after release and test on prod
export const DISCO_BE_PRICE_FORMAT = 'DISCO-BE-price-format';
export const DISCO_BE_DATE_FORMAT = 'DISCO-BE-date-format';
export const ODS_BE_NEW_MAP = 'OSD-BE-new-map';
export const ODS_NEW_SEARCH = 'ODS-BE-NEW_SEARCH';
